module.exports = __webpack_public_path__ + "img/clock-icon.7e4f13ae.svg";